// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__Y0eyC","varNumber":"Variant_varNumber__kAY9F","varTitle":"Variant_varTitle__fo9dH"};